import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable, tap } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse, LoginValue, Menu, User } from '../models/api-response.model';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private readonly http = inject(HttpClient);
  private readonly tokenKey = 'mh_re_dsm_token';
  private readonly userKey = 'mh_re_dsm_user';

  login(payload: LoginRequest): Observable<ApiResponse<LoginValue>> {
    return this.http.post<ApiResponse<LoginValue>>(API_ENDPOINTS.auth.login, payload).pipe(
      tap((response) => {
        if (response.status === 'TRUE' && response.value !== '') {
          sessionStorage.setItem(this.tokenKey, response.value.access_token);
          sessionStorage.setItem(this.userKey, JSON.stringify(response.value.user));
        }
      })
    );
  }

  logout(): void {
    sessionStorage.removeItem(this.tokenKey);
    sessionStorage.removeItem(this.userKey);
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.tokenKey);
  }

  getCurrentUser(): User | null {
    const user = sessionStorage.getItem(this.userKey);
    return user ? JSON.parse(user) as User : null;
  }

  getAssignedMenus(): Observable<ApiResponse<Menu[]>> {
    if (!this.getToken()) {
      return EMPTY;
    }
    return this.http.get<ApiResponse<Menu[]>>(API_ENDPOINTS.auth.menus);
  }

  changePassword(payload: ChangePasswordRequest): Observable<ApiResponse<User>> {
    return this.http.patch<ApiResponse<User>>(API_ENDPOINTS.auth.changePassword, payload);
  }

  hasRole(roles: readonly string[]): boolean {
    const roleName = this.getCurrentUser()?.role?.name;
    return roleName ? roles.includes(roleName) : false;
  }
}
